import * as angular from 'angular';

export enum Units {
  gallons,
  inches,
  ounces,
  gallons_ounces,
  liters,
  feet,
  meters,
  lbs,
  mA
}

angular.module('ciApp').constant('Units', Units);



// WEBPACK FOOTER //
// ./common/constants/units.ts